export const computeAgeSummary = (labels, values) => {
  let newTickets = 0;
  let oldTickets = 0;

  labels.forEach((label, i) => {
    const value = values[i] || 0;
    
    // New format from backend: "0-7 days", "8-14 days", "15-30 days", "31-60 days", "61-90 days", "90+ days"
    // New tickets: 0-7 days (first 7 days)
    if (label.includes("0-7") || label.includes("0-1") || label.includes("2-3") || label.includes("4-5") || label.includes("6-7")) {
      newTickets += value;
    }

    // Old tickets: 31+ days (tickets older than 30 days)
    // Support both new format (31-60, 61-90, 90+) and old format (31-45, 46-60, 61-75, 76-90, 90-120, 120+)
    if (label.includes("31-60") || label.includes("61-90") || label.includes("90+") ||
        label.includes("31-45") || label.includes("46-60") || label.includes("61-75") || 
        label.includes("76-90") || label.includes("90-120") || label.includes("120+")) {
      oldTickets += value;
    }
  });

  return { newTickets, oldTickets };
};
